export * as BooleanUtil from './boolean-util'
export * as CssUtil from './css-util'
export * as DateUtil from './DateUtil'
export * as DomUtil from './DomUtil'
export * from './Error'
export * as MathUtil from './MathUtil'
export * as NumberUtil from './number-util'
export * as NumberFormat from './NumberFormat'
export * as StringUtil from './StringUtil'
export * from './platform-util'

export const DATE_FORMAT = {
  dd_MM_yy: 'dd.MM.yy',
  dd_MM_yyyy: 'dd.MM.yyyy',
  HH_mm: 'HH:mm',
  HH_mm_ss: 'HH:mm:ss',
  dd_MM_yy__HH_mm: 'dd.MM.yy HH:mm',
  dd_MM_yy__HH_mm_ss: 'dd.MM.yy HH:mm:ss',
  MMMM_d__HH_mm_ss: 'MMMM do HH:mm:ss',
  HH_mm__dd_MM_yy: 'HH:mm dd.MM.yy',
  HH_mm_ss__dd_MM_yy: 'HH:mm:ss dd.MM.yy',
}
